import React, { useEffect } from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const handleScroll = () => {
    const steps = document.querySelectorAll('.how-it-works-step');
    steps.forEach(step => {
      const rect = step.getBoundingClientRect();
      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        step.classList.add('in-view');
      } else {
        step.classList.remove('in-view');
      }
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Trigger on mount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="how-it-works-section">
      <h2>How It Works</h2>
      <p>Here&apos;s a step-by-step guide to booking a video consultation with a doctor:</p>

      <div className="how-it-works-steps">
        {/* Step 1 */}
        <div className="how-it-works-step animated slide-in-left">
          <div className="text">
            <h3>Create an Account or Log In</h3>
            <p>Begin by registering a new account or logging into your existing profile.</p>
          </div>
          <div className="image">
            <img src="/createaccount.jpg" alt="Create an Account" />
          </div>
        </div>

        {/* Step 2 */}
        <div className="how-it-works-step animated slide-in-right">
          <div className="text">
            <h3>Search for a Doctor</h3>
            <p>Utilize filters such as specialty and location to find a suitable doctor.</p>
          </div>
          <div className="image">
            <img src="/searchdoctor.png" alt="Search for a Doctor" />
          </div>
        </div>

        {/* Step 3 */}
        <div className="how-it-works-step animated slide-in-left">
          <div className="text">
            <h3>Book a Video Consultation</h3>
            <p>Schedule a video consultation at a time that is convenient for you.</p>
          </div>
          <div className="image">
            <img src="bookconsulation.png" alt="Book a Video Consultation" />
          </div>
        </div>

        {/* Step 4 */}
        <div className="how-it-works-step animated slide-in-right">
          <div className="text">
            <h3>Consult with the Doctor</h3>
            <p>Engage in the video consultation to receive the necessary treatment and advice.</p>
          </div>
          <div className="image">
            <img src="/consultatewithdoctor.jpg" alt="Consult with the Doctor" />
          </div>
        </div>

        {/* Step 5 */}
        <div className="how-it-works-step animated slide-in-left">
          <div className="text">
            <h3>Provide Feedback</h3>
            <p>After the consultation, offer feedback to help improve the service.</p>
          </div>
          <div className="image">
            <img src="/feedback.png" alt="Provide Feedback" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;